// itandi_task側で定義されているワークフローのドメイン

export type ItandiTaskWorkflowStatus = "progress" | "completed" | "canceled";

// itandi_task側でbuiltinとして定義されているワークフロータグのsystem_key
export const BUILTIN_WORKFLOW_TAG_SYSTEM_KEY = {
	AFTER_THE_FACT_APPROVAL: "after_the_fact_approval",
	APPROVAL_REQUIRED: "approval_required"
} as const;

type BuiltinWorkflowTagSystemKey =
	(typeof BUILTIN_WORKFLOW_TAG_SYSTEM_KEY)[keyof typeof BUILTIN_WORKFLOW_TAG_SYSTEM_KEY];

export type BuiltinWorkflowTag = {
	label: string;
	systemKey: string;
};

export const hasBuiltinWorkflowTag = (
	tags: readonly BuiltinWorkflowTag[],
	systemKey: BuiltinWorkflowTagSystemKey
): boolean => tags.some((tag) => tag.systemKey === systemKey);

export type WorkflowDefinition = {
	builtinWorkflowTags: BuiltinWorkflowTag[];
	description: string | null;
	id: number;
	name: string;
};
